export class AppConfig {
  httpURL: string;
  wsURL: string;
  socketIOURL: string;
  version: string;
  pathToGraphQL: string;
  maxEncoderLineTime: number;
  defaultEncoderLineTime: number;
  relayURL: string;
}

// In main.ts a fetch is made to /assets/config.json and setConfig is called with the result.
// This allows the CI/CD pipeline to inject the correct configuration for the environment.
const httpURL = window.location.origin;
const wsURL = httpURL.replace(/^http/, 'ws');
const socketIOURL = httpURL.replace(/^https/, 'ws') + '/socket.io';
console.log(socketIOURL);
export let config = {
  httpURL,
  wsURL,
  socketIOURL,
  pathToGraphQL: "/graphql",
  version: "Local",
  maxEncoderLineTime: 1000,
  defaultEncoderLineTime: 10,
  relayURL: null
} as Partial<AppConfig>;
export default {setConfig: (c:AppConfig) => {
  config = {...config, ...c};
    console.log(config);

  }};
